import { createFileRoute } from '@tanstack/react-router';

import { LodgingRequests } from '../modules/Lodging/LodgingRequests/main';

export const Route = createFileRoute('/lodgingRequests')({
  component: LodgingRequests,
});
